// plugins/0.11.vue-code-layout.client.ts
import VueCodeLayout from '@edanweis/vue-code-layout'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueCodeLayout)
})